import baseRoute from '../baseRoute';

export type * from './requestModel';

type RouteDefinition = `${typeof baseRoute}/sendManualForMultipleWorkOrders`;

export const ROUTE: RouteDefinition = `${baseRoute}/sendManualForMultipleWorkOrders`;

export const URL = (): RouteDefinition => `${baseRoute}/sendManualForMultipleWorkOrders`;
